import React from 'react';
import { Link } from 'react-router-dom';
import Team from '../Component/Team';
import YLSLOGO from '../Assets/YLSNLOGO.jpg';

const About = () => {
  const highlights = [
    {
      title: 'Public Health Model',
      desc: 'Tackling community violence at its root through proactive street outreach, conflict resolution, and preventive support.'
    },
    {
      title: 'Wrap-Around Youth Support',
      desc: 'Providing personalized mentorship, education, job readiness, and crisis intervention tailored to each individual.'
    },
    {
      title: 'Community Collaboration',
      desc: 'Building lasting partnerships with families, schools, courts, and local leaders to foster sustainable safety.'
    }
  ];

  return (
    <div className="about-page">
      {/* 1. Simple, Readable Hero */}
      <section className="about-clean-hero">
        <div className="about-clean-hero-inner">
          <span className="badge-chip">501(c)(3) NON-PROFIT ORGANIZATION</span>
          <h1>About Youth L.I.F.E. Support Network</h1>
          <p>
            Dedicated to public safety, violence intervention, youth advocacy, and family support across Schenectady, Albany, and the Capital Region.
          </p>
        </div>
      </section>

      {/* 2. Main Story & Overview (High Readability) */}
      <section className="about-main-content">
        <div className="about-container">
          <div className="about-overview-grid">
            <div className="about-image-column">
              <img src={YLSLOGO} alt="Youth L.I.F.E. Support Network Logo" className="about-featured-img" />
              <div className="about-est-badge">
                <i className="fa-solid fa-calendar-check"></i>
                <span>Established in 2012 &bull; 12+ Years of Impact</span>
              </div>
            </div>

            <div className="about-text-column">
              <span className="section-subtitle">OUR MISSION</span>
              <h2>Building Stronger, Safer Communities Together</h2>
              
              <p className="lead-paragraph">
                Youth L.I.F.E. Support Network, Inc. is a community-based 501(c)(3) non-profit organization dedicated to promoting public safety and empowering at-risk youth and families in high-risk areas.
              </p>
              
              <p className="body-paragraph">
                Embracing a public health model approach, we address community violence through proactive outreach, crisis mediation, educational support, recreation, and advocacy. We give youth a seat at the table to help shape the direction and future of our community.
              </p>

              <div className="about-highlight-box">
                <i className="fa-solid fa-quote-left"></i>
                <p>
                  "The Youth are the Leaders of tomorrow. We must work collectively to empower and support their visions and feed their ambitions."
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3. Simple 3-Column Focus Areas */}
      <section className="about-focus-section">
        <div className="about-container">
          <div className="text-center mb-10">
            <span className="section-subtitle">HOW WE MAKE A DIFFERENCE</span>
            <h2>Our Core Strategic Focus</h2>
          </div>

          <div className="about-focus-grid">
            {highlights.map((item, idx) => (
              <div key={idx} className="focus-card">
                <div className="focus-number">0{idx + 1}</div>
                <h3>{item.title}</h3>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* 4. Team Showcase */}
      <Team />

      {/* 5. Clean Closing Callout */}
      <section className="about-closing-banner">
        <div className="about-container text-center">
          <h2>Without a "Network", there can be no REAL success!</h2>
          <p>Contact our outreach team or learn how you can support our mission.</p>
          <div className="about-closing-actions">
            <Link to="/contact" className="btn-brand-primary">
              Contact Support Team <i className="fa-solid fa-arrow-right"></i>
            </Link>
            <Link to="/programs" className="btn-brand-outline">
              Explore Core Programs
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;